<template>
  <el-form ref="productPropertyForm" :model="formData" label-width="200px" :disabled="disabled">
    <el-row>
      <el-col v-for="(item, index) in formData.materialPropertyVOES" :key="index" :span="8">
        <el-form-item :label="item.propertyName" :prop="'materialPropertyVOES.' + index + '.propertyValue'" :rules="{ required: item.mustInput, message: '请输入', trigger: 'change' }">
          <template v-if="String(item.dataType) === '1000'">
            <el-input v-model="item.propertyValue"/>
          </template>
          <template v-else-if="String(item.dataType) === '1001'">
            <el-input-number v-model="item.propertyValue" :precision="0"/>
          </template>
          <template v-else-if="String(item.dataType) === '1002'">
            <el-input-number v-model="item.propertyValue" :precision="2"/>
          </template>
          <template v-else-if="['1004', '1005'].includes(String(item.dataType))">
            <el-select v-model="item.propertyValue" filterable :multiple="Number(item.valueType) === 1">
              <el-option v-for="value in item.propertyDetails" :key="value.propertyValue" :label="value.displayValue" :value="value.propertyValue"/>
            </el-select>
          </template>
          <template v-else-if="String(item.dataType) === '1006'">
            <el-radio-group v-model="item.propertyValue">
              <el-radio
                  v-for="value in item.propertyDetails"
                  :key="value.propertyValue"
                  :label="value.displayValue"
                  :value="value.propertyValue"/>
            </el-radio-group>
          </template>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  export default {
    props: {
      productList: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        formData: {
          materialPropertyVOES: [],
        },
      };
    },
    mounted() {
      this.initFormData();
    },
    methods: {
      initFormData() {
        this.formData.materialPropertyVOES = (this.productList || []).map(item => {
          // 处理多选下拉框：将逗号分隔的字符串转为数组
          if (Number(item.valueType) === 1 && typeof item.propertyValue === "string") {
            const { propertyValue, ...rest } = item;
            return {
              ...rest,
              propertyValue: propertyValue.split(","),
            };
          }
          return item;
        });
      },
      getRef() {
        return this.$refs.productPropertyForm;
      },
      resetFields() {
        this.$refs.productPropertyForm.resetFields();
      },
      updateProductForm() {
        const processedData = this.formData.materialPropertyVOES.map(item => {
          if (Number(item.valueType) === 1 && Array.isArray(item.propertyValue)) {
            const {propertyValue, ...rest} = item;
            return {
              ...rest,
              propertyValue: propertyValue.join(","),
            };
          }
          return item;
        });
        this.$emit("UpdateProductForm", processedData);
      },
    },
  };
</script>

<style scoped>
::v-deep .el-form-item--mini .el-form-item__content{
  line-height: 27px;
}
</style>
